module.exports = __webpack_public_path__ + "static/media/AlricvandenBroek.d83737d4.MP4";